<div class="kw-page" [nbSpinner]="this.isLoading">

  <div class="kw-page-header">
    <div class="title-block">
      <h2 class="page-title">{{"Package" | tenantWords}} Types</h2>
      <span class="page-subtitle">Manage {{"Package" | tenantWords}} weights, dimensions, pallet counts, and components</span>
    </div>
    <div class="header-actions">
      <button mat-raised-button color="primary" class="header-btn primary-btn" (click)="createPackageType()">
        <fa-icon [icon]="faPlus" class="me-2"></fa-icon>Create {{"Package" | tenantWords}} Type
      </button>
    </div>
  </div>

  <div class="filters-bar">
    <div class="search-box">
      <fa-icon [icon]="faSearch" class="search-icon"></fa-icon>
      <input type="text" class="search-input" placeholder="Search by name or description..."
        [(ngModel)]="searchTerm" (ngModelChange)="applyFilters()" aria-label="Search package types">
    </div>

    <div class="chip-group status-chips" role="group" aria-label="Status">
      <button type="button" class="chip" *ngFor="let chip of this.statusChips" [class.active]="this.statusFilter === chip.key"
        (click)="setStatusFilter(chip.key)">
        {{chip.label}} <b>{{this.counts[chip.key] | number}}</b>
      </button>
    </div>
  </div>

  <div class="grid-card">
    <ejs-grid #grid [dataSource]="this.rows" [columns]="this.columns" [allowPaging]="true"
      [pageSettings]="this.pageSettings" [allowSorting]="true" [enableStickyHeader]="true" [enableHover]="true"
      (rowSelected)="onRowSelected($event)" (rowDataBound)="onRowDataBound($event)">
    </ejs-grid>
  </div>

  <!-- Grid templates -->
  <ng-template #nameTemplate let-data>
    <div class="item-name">{{data.name}}</div>
    <div class="item-sub" *ngIf="data.description">{{data.description}}</div>
  </ng-template>

  <ng-template #weightTemplate let-data>
    <span *ngIf="data.weightLabel; else blank">{{data.weightLabel}}</span>
  </ng-template>

  <ng-template #dimensionsTemplate let-data>
    <span *ngIf="data.dimensions; else blank">{{data.dimensions}}</span>
  </ng-template>

  <ng-template #componentTemplate let-data>
    <span class="type-pill" [class.empty]="!data.componentLabel">{{data.componentLabel || 'None'}}</span>
  </ng-template>

  <ng-template #statusTemplate let-data>
    <span class="status-tag" [class.status-available]="data.isActive"><span class="status-dot"></span>{{data.statusLabel}}</span>
  </ng-template>

  <ng-template #actionTemplate let-data>
    <fa-icon [icon]="faChevronRight" class="row-chevron"></fa-icon>
  </ng-template>

  <ng-template #blank><span class="blank">—</span></ng-template>

  <!-- Mobile card list: replaces the grid on small screens -->
  <div class="kw-mobile-list">
    <div class="m-card" *ngFor="let row of this.rows | slice:0:mobileVisibleCount; trackBy: trackByRow" (click)="openEdit(row)">
      <div class="m-card-top">
        <div>
          <div class="m-card-name">{{row.name}}</div>
          <div class="m-card-sub" *ngIf="row.description">{{row.description}}</div>
        </div>
        <span class="status-tag" [class.status-available]="row.isActive"><span class="status-dot"></span>{{row.statusLabel}}</span>
      </div>

      <div class="m-qty-grid">
        <div class="m-qty"><span>Weight</span><b>{{row.weightLabel || '—'}}</b></div>
        <div class="m-qty"><span>Per pallet</span><b>{{row.quantityPerPallet != null ? (row.quantityPerPallet | number) : '—'}}</b></div>
        <div class="m-qty"><span>Unit</span><b>{{row.unitOfMeasure || '—'}}</b></div>
      </div>

      <div class="m-card-foot">
        <span class="type-pill" *ngIf="row.componentLabel; else dimsPill">{{row.componentLabel}}</span>
        <ng-template #dimsPill>
          <span class="type-pill" [class.empty]="!row.dimensions">{{row.dimensions || 'No dimensions'}}</span>
        </ng-template>
        <div class="m-card-actions">
          <button mat-icon-button [attr.aria-label]="'Edit ' + row.name" (click)="openEdit(row); $event.stopPropagation()">
            <fa-icon [icon]="faChevronRight"></fa-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="m-empty" *ngIf="!this.rows.length && !this.isLoading">
      <fa-icon [icon]="faBoxOpen" class="m-empty-icon"></fa-icon>
      <div>No {{"Package" | tenantWords}} types match your filters</div>
    </div>

    <button class="m-show-more" *ngIf="this.rows.length > mobileVisibleCount" mat-stroked-button (click)="showMoreMobile()">
      Show more ({{this.rows.length - mobileVisibleCount}} remaining)
    </button>
  </div>

</div>
